import { HR_LEFT_MENUS } from 'config/hrMenuConfig';
import { walkMenusWithPath } from 'system/menuPathUtil';

/** 메뉴 트리에서 screenId(또는 progId)로 leaf를 찾는다. */
export function findMenuByScreenId(screenId) {
  const key = String(screenId || '').trim();
  if (!key) return null;
  let found = null;
  Object.values(HR_LEFT_MENUS || {}).forEach((trees) => {
    if (found) return;
    walkMenusWithPath(trees, (node, pathLabels) => {
      if (found) return;
      if (node.children?.length) return;
      const sid = node.screenId || node.progId || '';
      if (sid === key) found = { ...node, pathLabels };
    });
  });
  return found;
}

export function menuToTabPayload(menuItem) {
  if (!menuItem) return null;
  const componentPath = menuItem.componentPath || '';
  const url = menuItem.url || menuItem.path || '';
  const progId = menuItem.progId || '';
  const menuId = menuItem.id || menuItem.menuNo;
  const menuLabel = menuItem.label || menuItem.menuNm || '메뉴';
  const component = menuItem.component || progId || componentPath || menuItem.id || menuItem.menuNo;
  const menuPath =
    Array.isArray(menuItem.pathLabels) && menuItem.pathLabels.length
      ? menuItem.pathLabels
      : [menuLabel];
  return {
    id: menuId,
    label: menuLabel,
    path: url || `/${component}`,
    component,
    componentPath,
    screenId: menuItem.screenId || menuItem.progId || '',
    menuPath,
  };
}
